import history from 'src/configuration/history';

const backToListView = (historyConfig?: any) => {
  const {
    location: { pathname, search },
    push,
  } = historyConfig || history;
  const parts: string[] = pathname.split('/');
  parts.pop();
  push({ pathname: parts.join('/'), search });
};

export default backToListView;
